import { styled } from 'stitches.config'

export const StatsSpeakRoot = styled('section', {
  background: '$primary-700',
  padding: '$6 $3 $7 $3',
  color: '$accent-white',
  fontWeight: '$regular',

  '@bp2': {
    padding: '$8 $3',
  },
})

export const StatsBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  justifyContent: 'center',
  alignItems: 'center',
  color: '$accent-black',
  background: '$tertiary-200',
  borderRadius: '20px',
  padding: '$4 10px',
  width: '100%',
  maxWidth: '255px',

  '@bp2': {
    padding: '$5',
    flexDirection: 'row',
    maxWidth: '1292px',
    gap: '50px',
  },

  '@bp3': {
    gap: '100px',
  },
})

export const StatsColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0',
  width: '100%',
  maxWidth: '255px',

  '@bp2': {
    gap: '$2',
  },
})

export const Header = styled('h2', {
  fontSize: '$h2',
  textAlign: 'center',
  fontWeight: '$regular',
  paddingBottom: '$1',

  '@bp2': {
    fontSize: '$h1',
    paddingBottom: '$2',
  },
})

export const Subtitle = styled('h3', {
  fontSize: '$headline',
  fontWeight: '$regular',
  fontFamily: '$primary',
  textAlign: 'center',
  width: '100%',
  maxWidth: '300px',
  paddingBottom: '$3',

  '@bp2': {
    fontSize: '$h3',
    fontFamily: '$display',
    maxWidth: 'none',
  },
})

export const Percentage = styled('h3', {
  fontSize: '$h1',
  fontWeight: '$regular',
  textAlign: 'center',
})
